import { rewind } from "services/player/inputs/inputs/playQueue/actions";
import { isInputPlayQueueFromState } from "services/player/inputs/service/helpers";
import type { AudioContextModel } from "models/app/player/AudioContext";

export const playerRewind = (context: AudioContextModel) => {
    if (isInputPlayQueueFromState()) rewind(context);
};
